import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "cr",
  "aria-labelledby": "cr-title"
}
const _hoisted_2 = { class: "cr-head" }
const _hoisted_3 = { class: "cr-field" }
const _hoisted_4 = { class: "cr-field" }
const _hoisted_5 = { class: "cr-field cr-wide" }
const _hoisted_6 = {
  key: 0,
  class: "cr-error cr-wide",
  role: "alert"
}
const _hoisted_7 = { class: "cr-actions cr-wide" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 1,
  class: "cr-notice",
  role: "status"
}
const _hoisted_11 = {
  key: 2,
  class: "cr-error",
  role: "alert"
}
const _hoisted_12 = {
  key: 3,
  class: "cr-list",
  "aria-label": "Competitors added"
}
const _hoisted_13 = { class: "cr-item-main" }
const _hoisted_14 = { class: "cr-name" }
const _hoisted_15 = ["href"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 0,
  class: "cr-note"
}
const _hoisted_18 = { class: "cr-meta" }
const _hoisted_19 = ["disabled", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[7] || (_cache[7] = _createElementVNode("div", null, [
        _createElementVNode("h3", { id: "cr-title" }, "Add a competitor"),
        _createElementVNode("p", null, "Found a company we should be watching? Add it here and the next weekly edition researches it and adds it to the report.")
      ], -1)),
      (!_ctx.open)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "ai-btn cr-open",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openForm && _ctx.openForm(...args)))
          }, "Add a competitor"))
        : _createCommentVNode("", true)
    ]),
    (_ctx.open)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          class: "cr-form",
          novalidate: "",
          onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _cache[8] || (_cache[8] = _createElementVNode("label", { for: "cr-name" }, "Competitor name", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "cr-name",
              ref: "name",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.name) = $event)),
              type: "text",
              maxlength: "120",
              autocomplete: "off",
              required: "",
              placeholder: "e.g. Acme Ops"
            }, null, 512), [
              [_vModelText, _ctx.form.name]
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[9] || (_cache[9] = _createElementVNode("label", { for: "cr-website" }, [
              _createTextVNode("Website "),
              _createElementVNode("span", { class: "cr-opt" }, "(optional)")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              id: "cr-website",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.website) = $event)),
              type: "text",
              inputmode: "url",
              maxlength: "300",
              autocomplete: "off",
              placeholder: "https://"
            }, null, 512), [
              [_vModelText, _ctx.form.website]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[10] || (_cache[10] = _createElementVNode("label", { for: "cr-note" }, [
              _createTextVNode("Why, or where you found them "),
              _createElementVNode("span", { class: "cr-opt" }, "(optional)")
            ], -1)),
            _withDirectives(_createElementVNode("textarea", {
              id: "cr-note",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.note) = $event)),
              rows: "2",
              maxlength: "1000",
              placeholder: "e.g. A dealer mentioned them; they sell SOP software to manufacturers."
            }, null, 512), [
              [_vModelText, _ctx.form.note]
            ])
          ]),
          (_ctx.formError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.formError), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              type: "button",
              class: "cr-cancel",
              disabled: _ctx.saving,
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeForm && _ctx.closeForm(...args)))
            }, "Cancel", 8, _hoisted_8),
            _createElementVNode("button", {
              type: "submit",
              class: "ai-btn",
              disabled: _ctx.saving || !_ctx.form.name.trim()
            }, _toDisplayString(_ctx.saving ? 'Adding…' : 'Add competitor'), 9, _hoisted_9)
          ])
        ], 32))
      : _createCommentVNode("", true),
    (_ctx.notice)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.notice), 1))
      : _createCommentVNode("", true),
    (_ctx.loadError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createTextVNode(_toDisplayString(_ctx.loadError) + " ", 1),
          _createElementVNode("button", {
            type: "button",
            class: "cr-link",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.load && _ctx.load(...args)))
          }, "Try again")
        ]))
      : (_ctx.requests.length)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requests, (r) => {
              return (_openBlock(), _createElementBlock("li", {
                key: r.id,
                class: "cr-item"
              }, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, [
                    (_ctx.safeUrl(r.website))
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: _ctx.safeUrl(r.website),
                          target: "_blank",
                          rel: "noopener"
                        }, _toDisplayString(r.name), 9, _hoisted_15))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(r.name), 1)
                        ], 64))
                  ]),
                  _createElementVNode("span", {
                    class: _normalizeClass(["cr-status", 'cr-st-' + r.status])
                  }, [
                    (r.status == 'covered')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _cache[11] || (_cache[11] = _createTextVNode("Covered in the ", -1)),
                          (r.coveredEdition)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: "#",
                                onClick: _withModifiers(($event: any) => (_ctx.$emit('open-edition', r.coveredEdition)), ["prevent"])
                              }, _toDisplayString(_ctx.niceDate(r.coveredEdition)), 9, _hoisted_16))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode("latest")
                              ], 64)),
                          _cache[12] || (_cache[12] = _createTextVNode(" edition", -1))
                        ], 64))
                      : (r.status == 'declined')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode("Not added" + _toDisplayString(r.statusNote ? ': ' + r.statusNote : ''), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode("Requested · will be covered in the next edition")
                          ], 64))
                  ], 2)
                ]),
                (r.note)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(r.note), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_18, [
                  _createTextVNode(" Added" + _toDisplayString(r.requestedByName ? ' by ' + r.requestedByName : '') + " on " + _toDisplayString(_ctx.shortDate(r.createdAt)) + " ", 1),
                  (r.mine)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "cr-link",
                        disabled: _ctx.removing == r.id,
                        onClick: ($event: any) => (_ctx.remove(r))
                      }, _toDisplayString(_ctx.removing == r.id ? 'Removing…' : 'Remove'), 9, _hoisted_19))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
  ]))
}